//console.log("1.0");

/* funcionalidad consultar via whatsapp */
$(document).ready(function () {
    var productName = $("h1.product-title").text();
    productName = $.trim(productName);

    /* ============================================
     * FUNCIÓN DE CONSULTA POR WHATSAPP - COMENTADA
     * Para reactivar, descomentar el código siguiente
     * ============================================ */
    /*
    //$(".product-form--atc-button").removeClass("disabled");
    // Agregar estilos dinámicos con !important usando una hoja de estilos
    if (!$("#supps-disabled-button-styles").length) {
      $("<style id='supps-disabled-button-styles'>")
        .prop("type", "text/css")
        .html(".product-form--atc-button.disabled { background-color: #b0b0b0 !important; background: #b0b0b0 !important; border: 1px solid #b0b0b0 !important; border-color: #b0b0b0 !important; color: #000000 !important; } .product-form--atc-button.disabled .atc-button--text { color: #000000 !important; }")
        .appendTo("head");
    }
    
    function aplicarEstilosDisabled() {
      $(".product-form--atc-button.disabled").each(function() {
        var $btn = $(this);
        $btn.css("background-color","#b0b0b0");
        $btn.css("border","1px solid #b0b0b0");
        $btn.css("color","#000000");
        $btn.css("opacity","1");
      });
    }
    aplicarEstilosDisabled();
    // Re-aplicar después de un pequeño delay para asegurar que sobrescriba otros estilos
    setTimeout(aplicarEstilosDisabled, 100);
    setTimeout(aplicarEstilosDisabled, 500);
    $(".product-form--atc-button.disabled").removeAttr("disabled");
    $(".product-form--atc-button.disabled").click(function(){
        window.open("https://api.whatsapp.com/send/?phone=51971227771&text=Hola Music Market quiero consultar el stock de este producto '"+productName+"'&type=phone_number&app_absent=0");
    });
    $(".product-form--atc-button.disabled").hover(function(){
      $(this).css("cursor", "pointer");
    });
    */

    /* Calcular fecha de envío
    function calcularFechaEnvio(diasHabiles) {
        var hoy = new Date();
        var diasAgregados = 0;
        var fechaEntrega = new Date(hoy);

        // Empieza desde mañana si es hoy
        fechaEntrega.setDate(hoy.getDate() + 1);

        while (diasAgregados < diasHabiles) {
            var diaSemana = fechaEntrega.getDay(); // 0 = Domingo, 6 = Sábado

            // Solo contar días hábiles (lunes a sábado: 1-6, excluyendo domingo: 0)
            if (diaSemana >= 1 && diaSemana <= 6) {
                diasAgregados++;
            }

            // Si aún no hemos agregado los días necesarios, avanzar al siguiente día
            if (diasAgregados < diasHabiles) {
                fechaEntrega.setDate(fechaEntrega.getDate() + 1);
            }
        }

        return fechaEntrega;
    }

    function formatearFechaEspanol(fecha) {
        var diasSemana = ['DOMINGO', 'LUNES', 'MARTES', 'MIÉRCOLES', 'JUEVES', 'VIERNES', 'SÁBADO'];
        var meses = ['ENE', 'FEB', 'MAR', 'ABR', 'MAY', 'JUN', 'JUL', 'AGO', 'SEP', 'OCT', 'NOV', 'DIC'];

        var diaSemana = diasSemana[fecha.getDay()];
        var dia = fecha.getDate();
        var mes = meses[fecha.getMonth()];

        return diaSemana + ' ' + dia + ' ' + mes;
    }

    // Calcular y actualizar fecha de envío (4 días hábiles, lunes a sábado)
    var fechaEntrega = calcularFechaEnvio(2);
    var fechaFormateada = formatearFechaEspanol(fechaEntrega);

    var $shippingDate = $("#shipping-date");
    if ($shippingDate.length) {
        $shippingDate.text(fechaFormateada);
    }
    */

    // Calcular y actualizar texto de envío para el segundo banner - Lógica basada en product-type
    var $shippingBanner2 = $(".shipping-banner-2");
    var productType = $shippingBanner2.data("product-type") || "";
    var ahora = new Date();
    var horaActual = ahora.getHours();
    var textoEnvio = "";

    // Tipos que siempre muestran "mañana"
    var tiposProductos = [
        "productos", "producto",
        "guitarras", "guitarra",
        "pianos", "piano",
        "teclados", "teclado",
        "baterias", "bateria",
        "trompetas", "trompeta",
        "saxofones", "saxofon", "saxofón",
        "instrumentos de banda", "instrumento de banda",
        "timbales", "timbale",
        "congas", "conga",
        "tumbas quintos", "tumba quinto",
        "bongos", "bongo",
        "arregladores", "arreglador",
        "sintetizadores", "sintetizador"
    ];

    // Tipos que siguen la lógica de hora (accesorios, cuerdas, correas, soportes)
    var tiposAccesorios = ["accesorios", "accesorio", "cuerdas", "cuerda", "correas", "correa", "soportes", "soporte"];

    // Convertir productType a minúsculas para comparación
    productType = productType.toLowerCase().trim();

    // Verificar si es un tipo de producto (siempre mañana)
    var esProducto = tiposProductos.some(function (tipo) {
        return productType === tipo || productType.indexOf(tipo) !== -1;
    });

    // Verificar si es un tipo de accesorio (lógica de hora)
    var esAccesorio = tiposAccesorios.some(function (tipo) {
        return productType === tipo || productType.indexOf(tipo) !== -1;
    });

    if (esProducto) {
        // Si es producto, siempre mostrar "mañana"
        textoEnvio = "Se envía <strong>mañana</strong>";
    } else if (esAccesorio) {
        // Si es accesorio, aplicar lógica de hora
        if (horaActual < 12) {
            textoEnvio = "Se envía <strong>hoy</strong>";
        } else {
            textoEnvio = "Se envía <strong>mañana</strong>";
        }
    } else {
        // Por defecto, aplicar lógica de hora
        if (horaActual < 12) {
            textoEnvio = "Se envía <strong>hoy</strong>";
        } else {
            textoEnvio = "Se envía <strong>mañana</strong>";
        }
    }

    var $shippingDate2 = $("#shipping-date-2");
    if ($shippingDate2.length) {
        $shippingDate2.html(textoEnvio);
    }

    /* Update Stock Display on Variant Change */
    function updateStockDisplay(variantId) {
        var $inventoryJSON = $('[data-product-inventory-json]');
        if (!$inventoryJSON.length) return;

        var inventory = JSON.parse($inventoryJSON.html());
        var variant = inventory[variantId];
        if (!variant) return;

        var $stockContainer = $('[data-product-stock]');
        if (!$stockContainer.length) return;

        var realQuantity = variant.quantity || 0;
        var displayQuantity = realQuantity;
        if (realQuantity >= 4 && realQuantity <= 9) {
            displayQuantity = realQuantity - 3;
        }

        var stockHtml = '';
        if (variant.management === 'shopify') {
            if (realQuantity >= 10) {
                stockHtml = '<div class="product-stock--status in-stock">' +
                    '<span class="product-stock--icon"></span>' +
                    '<span class="product-stock--text">Disponible</span>' +
                    '</div>';
            } else if (displayQuantity > 5) {
                stockHtml = '<div class="product-stock--status in-stock">' +
                    '<span class="product-stock--icon"></span>' +
                    '<span class="product-stock--text">Stock disponible: <strong>' + displayQuantity + '</strong> unidades</span>' +
                    '</div>';
            } else if (displayQuantity > 0) {
                stockHtml = '<div class="product-stock--status low-stock">' +
                    '<span class="product-stock--icon"></span>' +
                    '<span class="product-stock--text">Stock disponible: <strong>' + displayQuantity + '</strong> unidades</span>' +
                    '</div>';
            } else {
                stockHtml = '<div class="product-stock--status out-of-stock">' +
                    '<span class="product-stock--icon"></span>' +
                    '<span class="product-stock--text">Agotado</span>' +
                    '</div>';
            }
        } else if (variant.available) {
            stockHtml = '<div class="product-stock--status in-stock">' +
                '<span class="product-stock--icon"></span>' +
                '<span class="product-stock--text">Disponible</span>' +
                '</div>';
        } else {
            stockHtml = '<div class="product-stock--status out-of-stock">' +
                '<span class="product-stock--icon"></span>' +
                '<span class="product-stock--text">Agotado</span>' +
                '</div>';
        }

        $stockContainer.html(stockHtml);
    }

    $(document).on('change', '[data-product-option]', function () {
        // give it a tiny delay for the theme JS to update the variant ID
        setTimeout(function () {
            var variantId = $('form[data-product-form] [name="id"]').val();
            updateStockDisplay(variantId);
        }, 100);
    });
});

